import { Box, Popover } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { MouseEvent, ReactNode, useState } from "react";
import BriaButton from "../../../../components/common/BriaButton/BriaButton";
import BriaTooltip from "../../../../components/common/BriaTooltip/BriaTooltip";
import styles from "./FiboPopover.module.scss";

type Props = {
	buttonText: string;
	tooltip: string;
	icon?: string | ReactNode;
	children: ReactNode;
	className?: string;
	disabled?: boolean;
};

const FiboPopoverButton = ({ tooltip, buttonText, icon, children, className, disabled }: Props) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<>
			<BriaTooltip title={tooltip}>
				<BriaButton
					className={clsx(styles.controlButton, className)}
					buttonType="tertiaryMedium"
					onClick={handleClick}
					disabled={disabled}
				>
					<Box className={styles.buttonTextContainer}>
						{icon ? (
							typeof icon === "string" ? (
								<img className={styles.icon} src={icon} alt="icon" />
							) : (
								icon
							)
						) : null}
						{buttonText}
					</Box>
				</BriaButton>
			</BriaTooltip>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				className={styles.popover}
			>
				{children}
			</Popover>
		</>
	);
};

export default observer(FiboPopoverButton);
